module.exports = __webpack_public_path__ + "media/assets_v3/images/csgo-ranks/17-acdf78a86a34c05263e76d3c8c63f4c7.png";